import { render, staticRenderFns } from "./DependantsShort.vue?vue&type=template&id=18fec1e8"
import script from "./DependantsShort.vue?vue&type=script&lang=js"
export * from "./DependantsShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports